import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { resetUIVisibility } from '../utils/uiUtils';

const RouteChangeListener = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  
  useEffect(() => {
    // Reset UI visibility when the route changes
    dispatch(resetUIVisibility());
  }, [location.pathname, dispatch]);
  
  return null; // This component doesn't render anything
};

export default RouteChangeListener;